import eight from '../assets/svg/projects/eight.svg'
import seven from '../assets/svg/projects/seven.svg'
import six from '../assets/svg/projects/six.svg'


export const projectsData = [
    {
        id: 1,
        projectName: 'Reserve Bus ',
        projectDesc: 'Your one-stop solution for hassle-free online bus ticket reservations. Experience convenience and real-time updates for a seamless travel experience.',
        tags: ['Full Stack Project'],
        code: 'https://github.com/SriS0/Reserve-Bus-Fronted',
        demo: 'https://reservebuses.onrender.com/',
        image: eight
    },
    {
        id: 2,
        projectName: 'CRUD Module',
        projectDesc: 'A CRUD module for capturing and managing user data using a MongoDB database and React frontend. Enjoy seamless data validation, storage, and listing with edit and delete functionalities.',
        tags: ['Full Stack Project'],
        code: 'https://github.com/SriS0/CRUD-Module-Frontend',
        demo: 'https://crudmodule.netlify.app/',
        image: six
    },
    {
        id: 3,
        projectName: 'Expenses Tracker',
        projectDesc: 'This expense tracking application is built using React.js and allows users to monitor their expenses data effectively. It provides a user-friendly interface for inputting and managing expenses information.',
        tags: ['Frontend Project'],
        code: 'https://github.com/SRI-SRINIVASAN-S/Expenses-Tracker',
        demo: 'https://expense-tracker-srini.netlify.app/',
        image: seven
    },
    {
        id: 4,
        projectName: 'Quiz App ',
        projectDesc: 'In this Quiz App, you can create your own quizzes and start answering questions. The score will be displayed based on your correct answers.',
        tags: ['Frontend  Project'],
        code: 'https://github.com/SRI-SRINIVASAN-S/Quiz-App-AlmaBetter-Fronted-Project-',
        demo: 'https://almabetter-capstoneprojectquizapp.netlify.app/',
        image: six
    },
    {
        id: 5,
        projectName: 'Get YouTube Subcribers',
        projectDesc: 'This project involves retrieving subscriber data from the backend when a user accesses a specific path. It aims to provide a seamless and efficient way for users to access this information.',
        tags: ['Backend Project'],
        code: 'https://github.com/SRI-SRINIVASAN-S/You-Tube-Subscribes-AlmaBetter-Backend-Project-',
        demo: 'https://almabetter-project2.onrender.com/',
        image: eight
    },
]